import {css} from 'lit'; export default css`:host chameleon-popover{--z-index:60000}:host .presence-menu-trigger{display:flex;align-items:center}`;
    